import ApiService from '@/common/api/api.service';

const TituloService = {
  listarTitulos(form) {
    return ApiService.post('/ConsultaTitulos', form);
  },
};

export default TituloService;
